<template>
  <soha-page-loading v-if="loading" />
  <div class="card card-custom gutter-b example example-compact p-8" v-else>
    <div class="row mx-0 my-5">
      <span class="soha-page-title">{{ $t(`${I18nPrefix}PAGE_TITLE`) }}</span>
    </div>
    <div class="row m-0 my-5">
      <div class="col-lg-12 mb-6">
        <h5 class="soha-notification-title">
          {{ $t(`${I18nPrefix}PUBLIC_NOTIFICATION`) }}
        </h5>
      </div>
      <div
        v-for="(notification, index) in publicNotifications"
        :key="index"
        class="col-lg-4 col-md-4 col-sm-6 col-12 mb-4"
      >
        <div class="soha-notification-card">
          <div class="soha-notification-card-header">
            <soha-checkbox
              :name="`check${notification.id}`"
              class="access-level-header mt-0 pt-0"
              :checkboxId="`checkedAll${notification.id}`"
              @change="checkAllItems(notification)"
              v-model="notification.checkedAll"
              :label="notification.name"
            />
          </div>
          <div>
            <soha-checkbox
              :name="`checkPublicProfile${notification.id}`"
              :checkboxId="`checkPublicProfile${notification.id}`"
              class="mt-0"
              :disable="
                notification.notifications.sms ||
                notification.notifications.email
              "
              @change="changePublicNotification(notification)"
              v-model="notification.notifications.profile"
              :label="$t(`${I18nPrefix}SYSTEM`)"
            />
            <soha-checkbox
              :name="`checkPublicSMS${notification.id}`"
              :checkboxId="`checkPublicSMS${notification.id}`"
              class="mt-0"
              @change="changePublicNotification(notification)"
              v-model="notification.notifications.sms"
              :label="$t(`${I18nPrefix}SMS`)"
            />
            <soha-checkbox
              :name="`checkPublicEmail${notification.id}`"
              :checkboxId="`checkPublicEmail${notification.id}`"
              class="mt-0"
              @change="changePublicNotification(notification)"
              v-model="notification.notifications.email"
              :label="$t(`${I18nPrefix}EMAIL`)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-0 my-5">
      <div class="col-lg-12 mb-6">
        <h5 class="soha-notification-title">
          {{ $t(`${I18nPrefix}JOB_NOTIFICATION`) }}
        </h5>
      </div>

      <div
        v-for="(notification, index) in jobNotifications"
        :key="index"
        class="col-lg-4 col-md-4 col-sm-6 col-12 mb-4"
      >
        <div class="soha-notification-card">
          <div class="soha-notification-card-header">
            <label class="font-weight-bold">
              {{
                jobList.length > 0 &&
                jobList.find((x) => x.id === +notification.jobId).text
              }}
            </label>
          </div>
          <div>
            <soha-checkbox
              :name="`checkJobProfile${notification.id}`"
              :checkboxId="`checkJobProfile${notification.id}`"
              class="mt-0"
              v-model="notification.profile"
              :disable="notification.sms || notification.email"
              :label="$t(`${I18nPrefix}SYSTEM`)"
            />
            <soha-checkbox
              :name="`checkJobSMS${notification.id}`"
              :checkboxId="`checkJobSMS${notification.id}`"
              class="mt-0"
              v-model="notification.sms"
              @change="changeJobNotification(notification)"
              :label="$t(`${I18nPrefix}SMS`)"
            />
            <soha-checkbox
              :name="`checkJobEmail${notification.id}`"
              :checkboxId="`checkJobEmail${notification.id}`"
              class="mt-0"
              v-model="notification.email"
              @change="changeJobNotification(notification)"
              :label="$t(`${I18nPrefix}EMAIL`)"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-4">
        <last-card
          @click="$bvModal.show('addJob')"
          class="soha-min-h-115px"
          :text="$t(`${I18nPrefix}ADD_JOB`)"
          icon="plus"
        />
      </div>
    </div>
    <div class="row m-0 my-5">
      <div class="col-lg-12 text-right">
        <soha-button
          variant="primary"
          name="insertNotificationSetting"
          @click="insertChanges"
          :loading="btnLoading"
          :text="$t(`${I18nPrefix}INSERT_CHANGE`)"
        />
      </div>
    </div>
    <soha-modal
      id="addJob"
      :title="$t(`${I18nPrefix}ADD_JOB`)"
      @hide="clearDataModal"
    >
      <template v-slot:body>
        <div class="col-lg-12">
          <soha-select
            class="w-100"
            v-model="selectedJob.id"
            :error="selectedJob.error"
            name="jobList"
            :placeholder="$t(`${I18nPrefix}JOB`)"
            :options="unSelectJob"
          />
        </div>
        <div class="row m-0 p-8 pl-20 justify-content-between">
          <soha-checkbox
            name="checkModalJobProfile"
            checkboxId="checkModalJobProfile"
            class="mt-0 col-sm-4"
            v-model="selectedJob.profile"
            :disable="selectedJob.sms || selectedJob.email"
            :label="$t(`${I18nPrefix}SYSTEM`)"
          />
          <soha-checkbox
            name="checkModalJobSMS"
            checkboxId="checkModalJobSMS"
            class="mt-0 col-sm-4"
            v-model="selectedJob.sms"
            @change="changeJobNotification(selectedJob)"
            :label="$t(`${I18nPrefix}SMS`)"
          />
          <soha-checkbox
            name="checkModalJobEmail"
            checkboxId="checkModalJobEmail"
            class="mt-0 col-sm-4"
            v-model="selectedJob.email"
            @change="changeJobNotification(selectedJob)"
            :label="$t(`${I18nPrefix}EMAIL`)"
          />
        </div>
      </template>
      <template v-slot:footer>
        <soha-button
          class="w-100"
          :loading="addJobLoading"
          name="insertJob"
          :text="$t(`${I18nPrefix}ADD_JOB`)"
          @click="addJobNotification"
        />
      </template>
    </soha-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ValidationMixin from "@/mixins/ValidationMixin";
import UIMixin from "@/mixins/UIMixin";
import ApiService from "@/core/services/api.service";
import LastCard from "@/view/components/base/LastCard";
export default {
  name: "Notification",
  mixins: [ValidationMixin, UIMixin],
  components: { LastCard },
  data() {
    return {
      I18nPrefix: "PAGES.SETTING.NOTIFICATION.",
      loading: false,
      btnLoading: false,
      addJobLoading: false,
      notifications: [],
      jobList: [],
      selectedJobs: [],
      publicNotifications: [],
      jobNotifications: [],
      selectedJob: {
        profile: false,
        sms: false,
        email: false,
        id: null,
        error: null,
      },
    };
  },

  mounted() {
    this.getJobs();
  },

  methods: {
    getNotifications() {
      ApiService.post("api/employer/indexNotification", {
        employerId: this.userInfo.userId,
        companyId: this.companyId,
      }).then((res) => {
        if (res.data.status == "error") {
          this.errorToast(res.data.message);
        } else {
          res.data.map((item) => {
            if (item.id != 4 && item.id != 5) {
              this.publicNotifications.push(item);
            } else if (item.id != 4) {
              this.jobNotifications = item.notifications.map((item) => {
                return {
                  ...item,
                  profile: item.profile == 1,
                  email: item.email == 1,
                  sms: item.sms == 1,
                };
              });
            }
          });
          this.publicNotifications.map((item) => {
            if (item.notifications.length === 0)
              item.notifications = {
                notificationTypeId: item.id,
                profile: false,
                sms: false,
                email: false,
              };
            else {
              item.notifications = {
                ...item.notifications[0],
                profile: item.notifications[0].profile == 1,
                email: item.notifications[0].email == 1,
                sms: item.notifications[0].sms == 1,
              };
              item.checkedAll =
                item.notifications.profile &&
                item.notifications.sms &&
                item.notifications.email;
            }
          });
        }
        this.loading = false;
      });
    },

    getJobs() {
      this.loading = true;
      ApiService.get(`api/v2/companies/${this.companyId}/jobs`).then((res) => {
        this.jobList = res.data.map((job) => {
          return {
            id: job.id,
            text: job.title,
          };
        });
        this.getNotifications();
      });
    },

    fillNotifications() {
      this.notifications = [];
      this.publicNotifications.map((item) => {
        if (
          !!+item.notifications.profile ||
          !!+item.notifications.sms ||
          !!+item.notifications.email
        )
          this.notifications.push({
            jobId: null,
            notificationTypeId: item.notifications.notificationTypeId,
            profile: item.notifications.profile,
            sms: item.notifications.sms,
            email: item.notifications.email,
          });
      });
      this.jobNotifications.map((item) => {
        if (!!+item.profile || !!+item.sms || !!+item.email)
          this.notifications.push({
            jobId: item.jobId,
            notificationTypeId: item.notificationTypeId,
            profile: item.profile,
            sms: item.sms,
            email: item.email,
          });
      });
    },

    insertChanges() {
      this.btnLoading = true;
      this.fillNotifications();
      ApiService.post("api/employer/createNotification", {
        employerId: this.userInfo.userId,
        companyId: this.companyId,
        notifications: this.notifications,
      }).then((res) => {
        if (res.data.status === "ok") {
          this.successToast(res.data.message);
          this.notifications = [];
          this.jobNotifications = this.jobNotifications.filter((job) => {
            return job.profile || job.email || job.sms;
          });
        } else {
          this.errorToast(res.data.message);
        }
        this.btnLoading = false;
      });
    },

    checkAllItems(notification) {
      notification.checkedAll
        ? (notification.notifications.profile =
            notification.notifications.sms =
            notification.notifications.email =
              true)
        : (notification.notifications.profile =
            notification.notifications.sms =
            notification.notifications.email =
              false);
    },

    changePublicNotification(notification) {
      notification.checkedAll =
        !!+notification.notifications.profile &&
        !!+notification.notifications.sms &&
        !!+notification.notifications.email;
      if (
        !!+notification.notifications.sms ||
        !!+notification.notifications.email
      )
        notification.notifications.profile = true;
    },

    changeJobNotification(notification) {
      if (notification.sms || notification.email) notification.profile = true;
    },

    clearDataModal() {
      this.selectedJob = {
        profile: false,
        sms: false,
        email: false,
        id: null,
        error: null,
      };
    },

    addJobNotification() {
      this.selectedJob.error = this.validateField(
        this.selectedJob.id,
        this.$t(`${this.I18nPrefix}JOB`),
        null,
        "select"
      );
      if (this.selectedJob.error) return;
      this.jobNotifications.push({
        email: this.selectedJob.email,
        jobId: this.selectedJob.id,
        notificationTypeId: "5",
        profile: this.selectedJob.profile,
        sms: this.selectedJob.sms,
      });
      this.$bvModal.hide("addJob");
    },
  },

  computed: {
    ...mapGetters(["userInfo", "companyId"]),

    unSelectJob() {
      return this.jobList.filter((job) => {
        return !this.jobNotifications.some((notification) => {
          return job.id === +notification.jobId;
        });
      });
    },
  },
};
</script>

<style scoped>
.soha-notification-card {
  border: 0.077rem solid var(--box-border-color);
  border-radius: 0.462rem;
  padding: 0.769rem 1.154rem;
  height: 100%;
}
.soha-notification-card-header {
  border-bottom: 0.077rem solid var(--box-border-color);
  margin-bottom: 0.769rem;
  color: var(--primary-color);
}

.soha-notification-title {
  background: #2f59a7;
  color: white;
  border-radius: 0.385rem;
  padding: 0.769rem;
  margin: 0;
}
</style>
